import backofficeService from '@/api/backoffice.js'
import terminalService from '@/api/terminal.js'

export default {

  getSubscriptionStatus() {
    return terminalService
      .Api()
      .get('subscription/status')
      .then(response => response.data)
      .catch(error => {
        throw error
      })
  },

  renewSubscription(data) {
    return terminalService
      .Api()
      .post('subscription/renew', data)
      .then(response => response.data)
      .catch(error => {
        throw error
      })
  },

  getSubscription(id, params = {}) {
    return terminalService
      .Api()
      .get('subscription/details', { params })
      .then(response => response.data)
      .catch(error => {
        throw error
      })
  },

  getCustomer(params = {}) {
    return terminalService
      .Api()
      .post(`stripe/terminal/getCustomer`, {
        params
      })
      .then(response => response.data)
      .catch(error => {
        throw error
      })
  },

  getCards(id, params = {}) {
    return terminalService
      .Api()
      .get(`stripe/terminal/cards`, {
        params
      })
      .then(response => response.data)
      .catch(error => {
        throw error
      })
  },

  addCard(data) {
    return terminalService.Api().post('stripe/terminal/addCard', data)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },

  getById(id, params = {}) {
    return backofficeService.Api().get(`location/${id}`, {
        params
      })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },
  getBilling(params = {}) {
    return backofficeService.Api().get(`billing`, {
        params
      })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })

  },

  create(data) {
    return backofficeService
      .Api()
      .post('location', data)
      .then(response => response.data)
      .catch(error => {
        throw error
      })
  },

  getUpcomingInvoice(id, params = {}) {
    return backofficeService
      .Api()
      .get(`location/${id}/billing/subscription/upcomingInvoice`, {
        params
      })
      .then(response => response.data)
      .catch(error => {
        throw error
      })
  },
  Terminal: {
    getById(id, params = {}) {
      return terminalService.Api().get(`location/${id}`, {
          params
        })
        .then(response => response.data)
        .catch((error) => {
          throw error
        })
    },
    update(id, data) {
      return terminalService
        .Api()
        .put(`location/${id}`, data)
        .then(response => response.data)
        .catch(error => {
          throw error
        })
    },
  },
  Billing: {
    /**
     * Get Subscription
     * @param {*} params Query Options
     */
    getInfo(id, params = {}) {
      return backofficeService
        .Api()
        .get(`location/${id}/billing`, {
          params
        })
        .then(response => response.data)
        .catch(error => {
          throw error
        })
    },
    /**
     * Update Subscription
     * @param {*} params Query Options
     */
    updateSubscription(id, data) {
      console.log('data sending', data)
      return backofficeService
        .Api()
        .post(`location/${id}/billing/updateSubscription`, data)
        .then(response => response.data)
        .catch(error => {
          throw error
        })
    },
    /**
     * start Subscription
     * @param {*} params Query Options
     */
    createSubscription(id, data) {
      console.log('create sending', data)
      return backofficeService
        .Api()
        .post(`location/${id}/billing/createSubscription`, data)
        .then(response => response.data)
        .catch(error => {
          throw error
        })
    },
    /**
     * Get Subscription
     * @param {*} params Query Options
     */
    getSubscription(id, params = {}) {
      return backofficeService
        .Api()
        .get(`location/${id}/billing/subscription`, {
          params
        })
        .then(response => response.data)
        .catch(error => {
          throw error
        })
    },
    /**
     * Get Subscription
     * @param {*} params Query Options
     */
    getCards(id, params = {}) {
      return backofficeService
        .Api()
        .get(`location/${id}/billing/cards`, {
          params
        })
        .then(response => response.data)
        .catch(error => {
          throw error
        })
    },
    /**
     * Get Invoice List
     * @param {*} params Query Options
     */
    getInvoiceListBySubscription(id, params = {}) {
      return backofficeService
        .Api()
        .get(`location/${id}/billing/invoice/list`, {
          params
        })
        .then(response => response.data)
        .catch(error => {
          throw error
        })
    },
    /**
     * Make a card default
     * @param {*} params Query Options
     */
    setDefaultCard(id, data) {
      return backofficeService
        .Api()
        .put(`location/${id}/billing/defaultSource`, data)
        .then(response => response.data)
        .catch(error => {
          throw error
        })
    },
    /**
     * Change Plan
     * @param {*} params Query Options
     */
    changePlan(id, data) {
      return backofficeService
        .Api()
        .post(`location/${id}/billing/changePlan`, data)
        .then(response => response.data)
        .catch(error => {
          throw error
        })
    },
    /**
     * cancel plan
     * @param {*} params Query Options
     */
    cancelPlan(id, data) {
      return backofficeService
        .Api()
        .post(`location/${id}/billing/cancel`, data)
        .then(response => response.data)
        .catch(error => {
          throw error
        })
    },
    /**
     * get customer by id
     * @param {*} params Query Options
     */
    getCustomer(id, data) {
      return backofficeService
        .Api()
        .post(`location/${id}/billing/getCustomer`, data)
        .then(response => response.data)
        .catch(error => {
          throw error
        })
    },
  },

}
